import React from "react";
import Slider from "react-slick";

import star1 from "../../../images/planes/star1.svg";
import star2 from "../../../images/planes/star2.svg";
import star3 from "../../../images/planes/star3.svg";

import fileteLeft from "../../../images/planes/fileteLeft.png";
import fileteRight from "../../../images/planes/fileteRight.png";
import fileteBottom from "../../../images/planes/fileteBottom.png";

import canal1 from "../../../images/canales/c_discovery.png";
import canal3 from "../../../images/canales/c_golden.png";

import dispositivosFull from "../../../images/planes/dispositivoFull.svg";
import ubicacionesFull from "../../../images/planes/ubicacionesFull.svg";
import dispositivosBasico from "../../../images/planes/dispositivoBasico.svg";
import ubicacionesBasico from "../../../images/planes/ubicacionesBasico.svg";

import Plan from "./Plan";

const TablasPlanes = ({ className, title, copy }) => {
  const settings = {
    centerMode: true,
    centerPadding: "0",
    arrows: false,
    slidesToShow: 2,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          arrows: false,
          centerMode: true,
          infinite: false,
          centerPadding: "10px",
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <section className={`TablasPlanes ${className}`}>
        <img src={fileteLeft} className="fileteLeft" />
        <img src={fileteRight} className="fileteRight" />
        <img src={fileteBottom} className="fileteBottom" />
        <div className="wrap">
          <h3 className="titles">{title}</h3>
          <p>{copy}</p>

          <div className="TablasPlanes__content">
            <div className="TablasPlanes__content-top">
              <div className="TablasPlanes__content-top-1ro">
                <img src={star1} className="star" />
                <h4>Más de 100 canales para ver en vivo.</h4>
              </div>
              <div className="TablasPlanes__content-top-2do">
                <img src={star2} className="star" />
                <h4>Contenido On Demand. Las mejores series y películas.</h4>
              </div>
              <div className="TablasPlanes__content-top-3ro">
                <img src={star3} className="star" />
                <h4>Incluye canales premium</h4>
                <span className="TablasPlanes__canales">
                  <figure className="TablasPlanes-canal">
                    <img src={canal1} />
                  </figure>
                  <figure className="TablasPlanes-canal">
                    <img src={canal3} />
                  </figure>
                </span>
              </div>
            </div>
            <div className="TablasPlanes__content-bottom">
              <Slider {...settings}>
                <div>
                  <Plan
                    className="masElegido"
                    plan="Plan Full"
                    precio="100"
                    imagenDispositivos={dispositivosFull}
                    dispositivos="5"
                    imagenUbicaciones={ubicacionesFull}
                    ubicaciones="4"
                    classNameLinkPrueba="button-primary"
                    copyLinkPrueba="Pruébalo gratis"
                    linkPrueba="#"
                    classNameLinkDetalles="button-gradient"
                    copyLinkDetalles="Suscríbete ahora"
                    linkDetalles="#"
                  />
                </div>
                <div>
                  <Plan
                    className="planBasico"
                    plan="Plan Básico"
                    precio="70"
                    imagenDispositivos={dispositivosBasico}
                    dispositivos="5"
                    imagenUbicaciones={ubicacionesBasico}
                    ubicaciones="2"
                    classNameLinkPrueba="button-primary"
                    copyLinkPrueba="Pruébalo gratis"
                    linkPrueba="#"
                    classNameLinkDetalles="button-gradient"
                    copyLinkDetalles="Suscríbete ahora"
                    linkDetalles="#"
                  />
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TablasPlanes;
